import { useEffect } from "react";
import { connect } from "react-redux";
import { useCheckSignIn } from "utils/hooks/hooks";

const RedirectToEsign = ({
  userData,
  updateUserData,
  dispatch,
  location,
  history,
}) => {
  const params = new URLSearchParams(location.search);
  const envelopeId = params.get("id");
  const serviceId = params.get("serviceid");
  const tenantId = params.get("tenantid");
  const loginHint = params.get("loginhint");

  const { checkUserStatus } = useCheckSignIn((data) =>
    dispatch(updateUserData(data))
  );

  useEffect(() => {
    if (!checkUserStatus) return;

    const vEditorEnvelope = `${window.location.origin}/esign-veditor/?id=${envelopeId}&serviceid=${serviceId}&from=1`;

    if (checkUserStatus)
      if (userData.id) {
        window.location.href = vEditorEnvelope;
      } else if (tenantId) {
        try {
          if (typeof window !== "undefined" && window.sessionStorage) {
            window.sessionStorage.setItem("postLoginUrl", vEditorEnvelope);
          }
        } catch (err) {
          console.error("Unable to cache SSO redirect url", err);
        }
        const ssoParams = new URLSearchParams();
        ssoParams.set("tenantId", tenantId);
        if (loginHint) ssoParams.set("login_hint", loginHint);
        history.push(`/sso?${ssoParams.toString()}`);
      } else {
        history.push(`/login?redirect=${encodeURIComponent(vEditorEnvelope)}`);
      }
  }, [
    userData.id,
    checkUserStatus,
    envelopeId,
    serviceId,
    history,
    tenantId,
    loginHint,
  ]);

  return null;
};

const mapStateToProps = ({ userData }) => ({ userData });

export default connect(mapStateToProps)(RedirectToEsign);
